export default __webpack_public_path__ + "img/5dcb71f56be93acb88c4168773367093.png";